import { Component, OnInit, OnDestroy, OnChanges, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import * as _ from 'lodash';
import { PlatformApp } from '../../../services/app.service';
import { PushNotificationsService, NotificationsService } from 'angular2-notifications';
import { filterFields } from "../../../formfields";

@Component({
    selector: 'filter-button',
    templateUrl: './filter-button.component.html',
    providers: [],
    styleUrls: ['./filter-button.component.scss']

})

export class FilterButtonComponent implements OnInit, OnDestroy, OnChanges {
    @Input() filters: string = '';
    @Input() datafields: string = '';
    @Output() onChanged: EventEmitter<any> = new EventEmitter<any>();

    currentuser: any;
    subscriptions: any = [];
    form: FormGroup;
    formFields: any = [];
    record: any = {};
    records: any = [];
    fields: any = [];
    formRecord: any = {};
    formOptions: any = {};
    notifyOptions = PlatformApp.getNotificationOptions();
    @ViewChild('filterModal') public filterModal: ModalDirective;

    constructor(private _LoopBackAuth: LoopBackAuth, private fb: FormBuilder,
        private _NotificationsService: NotificationsService, private _PushNotificationsService: PushNotificationsService) {
    }

    ngOnInit(): void {
        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        this.initForm();
        this.updateData();
    }

    ngOnChanges(changes) {
        this.updateData();
    }

    ngOnDestroy() {
        for (var i = 0; i < this.subscriptions.length; i++) this.subscriptions[i].unsubscribe();
    }

    updateData() {
        if (this.filters && this.filters !== '[{}]' && this.filters !== '[]' && this.filters !== "")
            this.records = JSON.parse(this.filters);
        else
            this.records = [];

        if (this.datafields && this.datafields !== '[{}]' && this.datafields !== '[]' && this.datafields !== "")
            this.fields = JSON.parse(this.datafields);
        else
            this.fields = [];
    }

    emitOutput(records) {
        this.onChanged.emit(records);
    }

    addFilter(formRecord) {
        let record = _.cloneDeep(formRecord);
        delete record.dataFields;

        if (formRecord.filtertype == 'select') {
            if (formRecord.filterValueType == 'date') {
                if (formRecord.filtercondition == 'is between') {
                    record.filtervalue = formRecord.filtervaluedatestart + ',' + formRecord.filtervaluedateend;
                    record.filtervalue_label = formRecord.filtervaluedatestart + ' , ' + formRecord.filtervaluedateend;
                } else {
                    record.filtervalue = formRecord.filtervalueselect;
                    record.filtervalue_label = formRecord.filtervalueselect_label;
                }
            } else {
                record.filtervalue = formRecord.filtervalueselect;
                record.filtervalue_label = formRecord.filtervalueselect_label;
            }
        }
        else {
            if (formRecord.filterValueType == 'number') {
                if (formRecord.filtercondition == 'is between') {
                    record.filtervalue = '[ ' + formRecord.filtervaluenumberstart + ' , ' + formRecord.filtervaluenumberend + ' ]';
                    record.filtervalue_label = record.filtervalue;
                } else {
                    record.filtervalue = formRecord.filtervalueinput;
                    record.filtervalue_label = formRecord.filtervalueinput;
                }
            } else {
                record.filtervalue = formRecord.filtervalueinput;
                record.filtervalue_label = formRecord.filtervalueinput;
            }
        }

        this.records.push(record);
        this.notify('success', 'Filter Added', record.filterfield_label + ' ' + record.filtercondition_label + ' ' + record.filtervalue_label);
        this.emitOutput(this.records);
        this.hideFilterModal();
    }

    initForm(): void {
        if (this.form && this.form['subscriptions'])
            this.form['subscriptions'].forEach(s => { s.unsubscribe(); });

        this.form = this.fb.group({});
        this.form['subscriptions'] = [];
    }

    public showFilterModal(): void {
        this.updateData();
        this.hideFilterModal();

        let recordKeys = [];
        this.records.forEach(function (record) { recordKeys.push(record.filterfield) });

        // let dataFields = [];
        // this.fields.forEach(function (field) {
        //     if (_.indexOf(recordKeys, field.key) < 0)
        //         dataFields.push(field);
        // });

        this.formRecord = { dataFields: this.fields };
        this.formFields = _.cloneDeep(filterFields);
        this.filterModal.show();
    }

    public hideFilterModal(): void {
        this.initForm();
        this.filterModal.hide();
    }

    resetFilterModal(): void {
        this.hideFilterModal();
        this.showFilterModal();
    }

    notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/filter-button/filter-button.component.ts